import { createSlice } from "@reduxjs/toolkit";
import {
  addImageToSchool,
  addNewSchool,
  AddNewSecretary,
  editSchool,
  getAllSchools,
  // getClassesForSchool,
  getSchoolInfo,
  getSchoolSecretaryAccounts,
} from "../services/school_service";
// ----------------------------------------------------------------------

const slice = createSlice({
  name: "school",
  initialState: {
    isLoadingAddNewSchool: false,
    isLoadingAllSchools: false,
    // isLoadingClassesForSchool: false
    newSchoolUserInfo: {},
    allSchools: [],
    schoolInfo: "",
    schoolClasses: [],
    // classInfo: {},
    isLoadingSchoolInfo: false,
    schoolInformation: {},
    isLoadingAddSecretary: false,
    isLoadingSchoolSecretaryAccounts: false,
    isLoadingEditSchool: false,
  },

  reducers: {
    setSchoolInfo: (state, action) => {
      state.schoolInfo = action.payload;
    },
  },

  extraReducers: {
    // ==> Add New School
    [addNewSchool.fulfilled]: (state, action) => {
      state.isLoadingAddNewSchool = false;
      state.newSchoolUserInfo = action.payload.data.user;
      if (
        action.payload.message === "Added Successfully" ||
        action.payload.message === "تمت الإضافة بنجاح"
      ) {
        window.location.href = "/manager/new-educational-institution-info";
      }
    },
    [addNewSchool.rejected]: (state, action) => {
      state.isLoadingAddNewSchool = false;
    },
    [addNewSchool.pending]: (state) => {
      state.isLoadingAddNewSchool = true;
    },

    // ==> get All Schools
    [getAllSchools.fulfilled]: (state, action) => {
      state.isLoadingAllSchools = false;
      state.allSchools = action.payload.data;
      // if (action.payload.message === "School created successfully") {
      //     window.location.href = '/dashboard/confirmed-school'
      // }
    },
    [getAllSchools.rejected]: (state, action) => {
      state.isLoadingAllSchools = false;
    },
    [getAllSchools.pending]: (state) => {
      state.isLoadingAllSchools = true;
    },
    // get school info
    [getSchoolInfo.fulfilled]: (state, action) => {
      console.log("fulfilled");
      console.log(action.payload.data);
      state.isLoadingSchoolInfo = false;
      state.schoolInformation = action.payload.data;
      state.schoolInfo = action.payload.data;
    },
    [getSchoolInfo.rejected]: (state, action) => {
      console.log("rejected");
      state.isLoadingSchoolInfo = false;
    },
    [getSchoolInfo.pending]: (state) => {
      state.isLoadingSchoolInfo = true;
    },

    // addImageToSchool
    [addImageToSchool.fulfilled]: (state, action) => {
      state.isLoadingAddImageToSchool = false;
      // state.newSchoolUserInfo = action.payload.data.user;
      if (
        action.payload.message === "Image uploaded successfully." ||
        action.payload.message === "تم رفع الصور بنجاح"
      ) {
        alert(action.payload.message);
        window.location.href = "/manager/educational_institution";
      }
    },
    [addImageToSchool.rejected]: (state, action) => {
      state.isLoadingAddImageToSchool = false;
    },
    [addImageToSchool.pending]: (state) => {
      state.isLoadingAddImageToSchool = true;
    },

    // AddNewSecretary
    [AddNewSecretary.fulfilled]: (state, action) => {
      state.isLoadingAddSecretary = false;
    },
    [AddNewSecretary.rejected]: (state, action) => {
      state.isLoadingAddSecretary = false;
    },
    [AddNewSecretary.pending]: (state) => {
      state.isLoadingAddSecretary = true;
    },

    // AddNewSecretary
    [getSchoolSecretaryAccounts.fulfilled]: (state, action) => {
      state.isLoadingSchoolSecretaryAccounts = false;
    },
    [getSchoolSecretaryAccounts.rejected]: (state, action) => {
      state.isLoadingSchoolSecretaryAccounts = false;
    },
    [getSchoolSecretaryAccounts.pending]: (state) => {
      state.isLoadingSchoolSecretaryAccounts = true;
    },

    // editSchool
    [editSchool.fulfilled]: (state, action) => {
      state.isLoadingEditSchool = false;
    },
    [editSchool.rejected]: (state, action) => {
      state.isLoadingEditSchool = false;
    },
    [editSchool.pending]: (state) => {
      state.isLoadingEditSchool = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setSchoolInfo } = slice.actions;
